module.exports = __webpack_public_path__ + "static/2-43342d9c85ed5cf8120582aa666b4567.png";